import { useEffect, useState } from 'react';
import {
  TournamentsService,
  MatchScheme,
} from '@base/features/tournaments/model/interfaces';
import { container } from 'tsyringe';
import { ResponseCode } from '@base/utils/constants';

type Scheme = {
  winners?: MatchScheme[][];
  losers?: MatchScheme[][];
  final?: MatchScheme[][];
};

export const useTournamentScheme = (idTourney: string) => {
  const [scheme, setScheme] = useState<Scheme>({
    winners: undefined,
    losers: undefined,
    final: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const tournamentsService: TournamentsService = container.resolve(
    'tournamentsService'
  );

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await tournamentsService.getTourneyScheme(idTourney);
        if (res && res.code === ResponseCode.SUCCESS) {
          setScheme({
            winners: populateMissingMatches(res.WINNERS),
            losers: res.LOSERS && populateMissingMatches(res.LOSERS),
            final: res.FINAL && [[res.FINAL], [{ '0': res.FINAL.W }]],
          });
        }
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    })();
    return () => setScheme({});
  }, [idTourney, tournamentsService]);

  return { scheme, loading, error };
};

function populateMissingMatches(tournament: MatchScheme[][]) {
  const EMPTY_MATCH = { '0': 'bye', '1': 'bye', W: '', L: 'bye' };
  const stages = [...tournament].reverse();
  const finalStage = stages.splice(0, 1);
  const populatedStages = stages.map((stage, index) => {
    const matchesPerCurrentStage = Math.pow(2, index);
    while (stage.length < matchesPerCurrentStage) {
      stage.push(EMPTY_MATCH);
    }
    return stage;
  });
  return finalStage.concat(populatedStages).reverse();
}
